import ACCOUNT from '@/api/lib/account'
import PATIENT_LIST from '@/api/lib/PatientList'
import USER_LIST from '@/api/lib/UserList'
import DEVICE_USAGE from '@/api/lib/DeviceUsage'
import PATIENT_PUBLIC_NOTE from '@/api/lib/PatientPublicNote'
import PATIENT from '@/api/lib/Patient'
import EXERCISE_LIST from '@/api/lib/ExerciseList'
import EXERCISE_RECORD from '@/api/lib/ExerciseRecord'
import MEASURE_RECORD from '@/api/lib/MeasureRecord'
import USER from '@/api/lib/User'
import SCHEDULE from '@/api/lib/Schedule'
import REPORT from '@/api/lib/Report'
import REMOTE from'@/api/lib/Remote'
import SOURCE from '@/api/lib/Source'
import PAYMENT from '@/api/lib/Payment'

export default {
	ACCOUNT, PATIENT_LIST, USER_LIST, DEVICE_USAGE, PATIENT_PUBLIC_NOTE,
	PATIENT, EXERCISE_LIST, EXERCISE_RECORD, MEASURE_RECORD, USER,
	SCHEDULE, REPORT, REMOTE, SOURCE, PAYMENT
}